import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { CircleActivityItem, CircleActivityState } from './types';

export const PAGE_SIZE = 20;

const initialState: CircleActivityState = {
  items: [],
  hasMore: true,
  isLoading: false,
  error: null
};

export const slice = createSlice({
  name: 'circleActivity',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      state.error = null;
    },
    setInitial(state, action: PayloadAction<CircleActivityItem[]>) {
      state.isLoading = false;
      state.items = action.payload;
      state.hasMore = action.payload.length >= PAGE_SIZE;
    },
    append(state, action: PayloadAction<CircleActivityItem[]>) {
      state.isLoading = false;
      state.items = state.items.concat(action.payload);
      state.hasMore = action.payload.length >= PAGE_SIZE;
    },
    hasError(state, action: PayloadAction<unknown>) {
      state.isLoading = false;
      state.error = action.payload;
    }
  }
});

export default slice.reducer;
